<template>
  <div class="sm:ml-2 lg:ml-12" ref="observerElement">
    <transition name="slide-up" appear v-if="isVisible">
      <div
        class="w-full flex flex-col lg:flex-row space-y-12 lg:space-y-0 lg:space-x-12 items-center lg:items-start justify-between mt-20 lg:mt-32 pr-2 lg:pr-12"
      >
        <div class="flex flex-col lg:items-start items-center w-full lg:w-1/2">
          <div
            class="font-rockinsoda text-navy text-5xl text-center lg:text-left lg:text-6xl"
          >
            <p>The Hanga SRH Cohort</p>
          </div>
          <div
            class="text-base lg:text-lg font-gramatika text-darkGray mt-6 text-center lg:text-left lg:text-justify w-full pl-2 lg:pl-0"
          >
            <p>
              Meet the top 20 tech-driven ventures selected for their innovative
              solutions. Each venture underwent an intensive 5-month incubation
              period, receiving a $10,000 grant to improve their solutions,
              alongside coaching by SRH and venture building experts, workshops,
              and matchmaking with funders.
            </p>
          </div>
        </div>
        <div
          class="w-full lg:w-1/2 h-[300px] lg:h-[400px] rounded-3xl overflow-hidden shadow-2xl mt-8 lg:mt-0"
        >
          <iframe
            class="w-full h-full"
            src="https://drive.google.com/file/d/127fY1AtMGxQqMJB_IK4jFy_Wk7dqw4jI/preview"
            title="Hanga SRH Video"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </transition>

    <div
      class="font-rockinsoda text-navy text-4xl mt-12 text-center lg:text-left lg:text-4xl font-bold"
    >
      <p>Hanga SRH Top 20 Ventures</p>
    </div>
    <div
      class="grid grid-cols-2 mr-4 ml-4 lg:ml-0 lg:mr-12 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 mt-6"
    >
      <ul
        v-for="startup in startups"
        :key="startup.name"
        class="border border-lightTangerine p-4 h-[28vh]"
      >
        <div id="startupVentDiv" class="flex items-center justify-center">
          <li>
            <router-link
              :to="{
                name: 'VenturesDescPage',
                params: { name: encodeURIComponent(startup.name) },
              }"
            >
              <transition name="fade-slide-up" appear v-if="isVisible">
                <img
                  :src="startup.logo"
                  alt="Logo"
                  class="max-w-full h-12 mt-6 mb-4 object-contain mx-auto"
                />
              </transition>

              <transition name="fade-slide-right" appear v-if="isVisible">
                <h3 class="text-center font-gramatika text-navy text-lg mt-4">
                  {{ startup.name }}
                </h3>
              </transition>
            </router-link>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilteredVentures",
  data() {
    return {
      startups: [
        // 2024 venture .................
        { name: "Afya Lead", logo: require("../assets/nsrh/afya.png") },
        { name: "Afya Wave", logo: require("../assets/nsrh/Afyawave.png") },
        { name: "Apiafrique", logo: require("../assets/nsrh/apiafrique.png") },
        { name: "Health Promotion Alliance of Cameroon (HPAC)", logo: require("../assets/nsrh/health-promotion.png") },
        { name: "Diversity Innovations Initiative (DIV)", logo: require("../assets/nsrh/div.png") },

        { name: "Famora Care", logo: require("../assets/nsrh/famora.png") },
        { name: "Health Promotion Organization (HPO)", logo: require("../assets/nsrh/HPO.png") },
        { name: "Ingabo HopeCore", logo: require("../assets/nsrh/ingabo.png") },
        { name: "Komfot Health", logo: require("../assets/nsrh/komfo.png") },
        { name: "Medvax Health", logo: require("../assets/nsrh/medvax.png") },

        { name: "MOCHCare", logo: require("../assets/nsrh/moch.png") },
        { name: "My Power App", logo: require("../assets/nsrh/mypower.png") },
        { name: "SAYE Company", logo: require("../assets/nsrh/saye.png") },
        { name: "SmartRR by Big Family 360", logo: require("../assets/nsrh/BFF.png") },
        { name: "Taboobreaker SA NPC", logo: require("../assets/nsrh/tabo.png") },

        { name: "Uchembere Wabwino maternity clinic", logo: require("../assets/nsrh/uchembere.png") },
        { name: "Umubyeyi Elevate", logo: require("../assets/nsrh/umubyeyi.png") },
        { name: "Wonkiliya Health Tech", logo: require("../assets/nsrh/wonkiliya.png") },
        { name: "Yene Health", logo: require("../assets/nsrh/yene.png") },
        { name: "Zivanae Afya Bora", logo: require("../assets/nsrh/ziva.png") },
      ],
      isVisible: false,
    };
  },

  mounted() {
    this.initiativeAnimations();

    if (this.$route.hash === "#startupVentDiv") {
      this.$nextTick(() => {
        const element = document.querySelector("#startupVentDiv");
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({
              behavior: "auto",
              block: "start",
            });
          }, 500);
        }
      });
    }
  },

  methods: {
    initiativeAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
          }
        });
      });

      observer.observe(this.$refs.observerElement);
    },
  },
};
</script>

<style>
.fade-in {
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
}

.fade-in-visible {
  opacity: 1;
}

.slide-up-enter-active,
.slide-left-enter-active,
.slide-right-enter-active {
  transition: all 0.7s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
  /* Ensure Y-axis is reset to 0 */
}

.slide-left-enter-from {
  opacity: 0;
  transform: translateX(-50px);
}

.slide-left-enter-to {
  opacity: 1;
  transform: translateX(0);
  /* Reset X-axis */
}

.slide-right-enter-from {
  opacity: 0;
  transform: translateX(50px);
}

.slide-right-enter-to {
  opacity: 1;
  transform: translateX(0);
  /* Reset X-axis */
}

/* General Fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease-in-out;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

/* Fade and Slide Up */
.fade-slide-up-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
}

.fade-slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.fade-slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

/* Fade and Slide Left */
.fade-slide-left-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
  /* Even slower and more natural */
}

.fade-slide-left-enter-from {
  opacity: 0;
  transform: translateX(-80px);
}

.fade-slide-left-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* Fade and Slide Right */
.fade-slide-right-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
  /* Even slower and more natural */
}

.fade-slide-right-enter-from {
  opacity: 0;
  transform: translateX(80px);
}

.fade-slide-right-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* Zoom In */
.zoom-enter-active {
  transition: all 0.7s ease;
}

.zoom-enter-from {
  opacity: 0;
  transform: scale(0.9);
}

.zoom-enter-to {
  opacity: 1;
  transform: scale(1);
}

.fade-slide-up-enter-active,
.fade-slide-up-leave-active {
  transition: opacity 1.1s ease-in-out, transform 1.1s ease-in-out;
}

.fade-slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.fade-slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-up-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-up-leave-to {
  opacity: 0;
  transform: translateY(80px);
}
</style>
